module.exports = __webpack_public_path__ + "static/media/FISH.d30e6a8e.svg";